(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const initStaggeredAnimation = () => {
      const grids = document.querySelectorAll('.logo-grid:not(.logo-grid-scroll)');
      grids.forEach(grid => {
        const items = grid.querySelectorAll('.logo-grid-item');
        items.forEach((item, index) => {
          item.style.setProperty('--index', index);
        });
      });
    };
    
    // Scroll functionality
    const initScrollableGrid = () => {
      const scrollGrids = document.querySelectorAll('.logo-grid-scroll');
      
      scrollGrids.forEach(grid => {
        const wrapper = grid.closest('.logo-grid-wrapper');
        if (!wrapper) return;
        
        const leftBtn = wrapper.querySelector('.scroll-left');
        const rightBtn = wrapper.querySelector('.scroll-right');
        const dots = wrapper.querySelectorAll('.scroll-dot');
        
        if (!leftBtn || !rightBtn) return;
        
        const updateButtons = () => {
          const scrollLeft = grid.scrollLeft;
          const maxScroll = grid.scrollWidth - grid.clientWidth;
          
          leftBtn.disabled = scrollLeft <= 0;
          rightBtn.disabled = scrollLeft >= maxScroll - 1;
        };
        
        const updateDots = () => {
          if (!dots.length) return;
          
          const scrollLeft = grid.scrollLeft;
          const maxScroll = grid.scrollWidth - grid.clientWidth;
          const scrollPercent = maxScroll > 0 ? scrollLeft / maxScroll : 0;
          const activeIndex = Math.round(scrollPercent * (dots.length - 1));
          
          dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === activeIndex);
          });
        };
        
        const updateAll = () => {
          updateButtons();
          updateDots();
        };
        
        leftBtn.addEventListener('click', () => {
          grid.scrollBy({
            left: -grid.clientWidth * 0.8,
            behavior: 'smooth'
          });
        });
        
        rightBtn.addEventListener('click', () => {
          grid.scrollBy({
            left: grid.clientWidth * 0.8,
            behavior: 'smooth'
          });
        });
        
        grid.addEventListener('scroll', updateAll);
        window.addEventListener('resize', updateAll);
        
        // Dot navigation
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const maxScroll = grid.scrollWidth - grid.clientWidth;
            const scrollPosition = (index / (dots.length - 1)) * maxScroll;
            grid.scrollTo({
              left: scrollPosition,
              behavior: 'smooth'
            });
          });
        });
        
        // Initial update
        setTimeout(updateAll, 100);
      });
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initStaggeredAnimation();
        initScrollableGrid();
      });
    } else {
      initStaggeredAnimation();
      initScrollableGrid();
    }
    
    const observeSection = () => {
      const observer = new MutationObserver(() => {
        initStaggeredAnimation();
        initScrollableGrid();
      });
      
      const section = document.querySelector('.logo-grid-section');
      if (section) {
        observer.observe(section, { childList: true, subtree: true });
      }
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeSection);
    } else {
      observeSection();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
